<template>
  <div class="copy-field">
    <p class="copy-label">{{ label }}</p>
    <div class="copy-box">
      <span class="copy-value">{{ value }}</span>
      <button
        type="button"
        class="copy-btn"
        :title="`Copy ${label}`"
        @click="$emit('copy')"
      >
        <svg v-if="copied" width="14" height="14" viewBox="0 0 16 16" fill="currentColor" class="icon-success">
          <path d="M13.485 1.929a.75.75 0 0 1 0 1.06l-7.778 7.778a.75.75 0 0 1-1.06 0L1.515 6.636a.75.75 0 1 1 1.06-1.06l2.657 2.657 7.248-7.248a.75.75 0 0 1 1.06 0z"/>
        </svg>
        <svg v-else width="14" height="14" viewBox="0 0 16 16" fill="currentColor" class="icon-copy">
          <path d="M0 6.75C0 5.784.784 5 1.75 5h1.5a.75.75 0 0 1 0 1.5h-1.5a.25.25 0 0 0-.25.25v7.5c0 .138.112.25.25.25h7.5a.25.25 0 0 0 .25-.25v-1.5a.75.75 0 0 1 1.5 0v1.5A1.75 1.75 0 0 1 9.25 16h-7.5A1.75 1.75 0 0 1 0 14.25v-7.5z"/>
          <path d="M5 1.75C5 .784 5.784 0 6.75 0h7.5C15.216 0 16 .784 16 1.75v7.5A1.75 1.75 0 0 1 14.25 11h-7.5A1.75 1.75 0 0 1 5 9.25v-7.5zm1.75-.25a.25.25 0 0 0-.25.25v7.5c0 .138.112.25.25.25h7.5a.25.25 0 0 0 .25-.25v-7.5a.25.25 0 0 0-.25-.25h-7.5z"/>
        </svg>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ShoplazzaCredentialCopyField',
  props: {
    label: {
      type: String,
      required: true,
    },
    value: {
      type: String,
      default: '',
    },
    copied: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../styles/variables.scss';

.copy-label {
  margin: 0 0 6px;
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: $ink-4;
}

.copy-box {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 12px;
  border: 1px solid $border;
  border-radius: 12px;
  background: #f9fafb;
}

.copy-value {
  flex: 1;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-size: 12px;
  color: $ink-2;
  word-break: break-all;
  user-select: all;
}

.copy-btn {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border: none;
  border-radius: 6px;
  background: transparent;
  cursor: pointer;
  transition: background 0.15s;

  &:hover {
    background: #e5e7eb;
  }
}

.icon-copy {
  color: $ink-4;
}

.icon-success {
  color: $green-dark;
}
</style>
